export enum EXCHANGERATE_TYPES {
  HUF_EUR = "HUF_EUR",
  USD_EUR = "USD_EUR",
}

